import React, { useState , useCallback} from "react";

import LanguageStringResolver from "../fields/language/LanguageStringResolver";
import { getMessageStatus } from "../inAppMessages/messagesHelper";
import { ApplicationMessagesIcons } from "../inAppMessages/ApplicationMessagesIcons";
import { SDashAlertCloseButton } from "../helper/sdash-pollyfills";
import Logger, { LOG_LEVELS } from "../../utils/logger";

const log = new Logger("APPLICATION_MESSAGES_BULKACTIONS", LOG_LEVELS.DEBUG);

const ApplicationMessagesForBulkAction = ({ messages, messageType, children, disableDismiss, tooltipWithParams, tooltipOffset }) => {
    const [visibleMessages, setVisibleMessages] = useState(messages);
    log.debug("Rendering with props:", { messages, messageType });

    const closeHandler = useCallback((messageToRemove) => {
        try {
            // Remove the specific message from visibleMessages
            setVisibleMessages(prevMessages => 
              prevMessages.filter((msg, idx) => idx !== messageToRemove)
            );
          
        } catch (error) {
            log.debug('Error closing alert:', error);
        }
    }, []);

    if (!messages || messages.length === 0) {
        log.debug("No messages to render");
        return null;
    }

    if (visibleMessages.length === 0) {
        return null;
    }

  const messageStatus = getMessageStatus(messageType);

  return (
      <div className="mb10">
          {messages.map((entry, index) => {
              return (
                  <s-alert key={entry.message.languageString} status={messageStatus} role="alert" nodismiss={disableDismiss} >
                      <ApplicationMessagesIcons messageStatus={messageStatus} />
                      <LanguageStringResolver
                          string={entry.message.languageString}
                          tooltip={entry.message.extendedLanguageString}
                          params={entry.args}
                          tooltipWithParams={tooltipWithParams}
                          tooltipOffset={tooltipOffset}
                      />
                      {entry.message.jobName && <span>{entry.message.jobName+". "}</span>}
                      {entry.details && <div className="message-details">{entry.details}</div>}
                      {children}
                      {!disableDismiss && <SDashAlertCloseButton onClose={() => closeHandler(index)} />}
                  </s-alert>
              );
          })}
      </div>
  );
};


ApplicationMessagesForBulkAction.defaultProps = {
    tooltipWithParams: true,
};

export default ApplicationMessagesForBulkAction;